<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download target="_blank" style="display: none"></a>

